import React from 'react';

function PendingTableMobile() {
    return (
        <div>
            <div className="text-xl font-medium text-primary">Pending Services</div>
        </div>
    );
}

export default PendingTableMobile;
